import { printerService } from './printerService';

class PrintService {
  constructor() {
    this.printerService = printerService;
  }

  async getPrinterConfig() {
    return this.printerService.getPrinterConfig();
  }

  async print(content, config) {
    try {
      if (config?.type === 'label' || config?.documentType === 'label') {
        return await this.printerService.printLabel(content, config);
      }
      return await this.printerService.printTicket(content, config);
    } catch (error) {
      console.error('Error al imprimir:', error);
      throw error;
    }
  }

  async printSale(saleData) {
    return await this.printerService.printTicket(saleData);
  }

  async printInvoice(data) {
    try {
      const sale = data.invoice || data.sale || data;
      return await this.printerService.printTicket(sale, {
        paperWidth: data.paperWidth || '58',
        copies: data.copies || 1,
        businessName: data.business?.business_name || data.businessName,
      });
    } catch (error) {
      console.error('Error al imprimir factura:', error);
      throw new Error('No se pudo imprimir la factura: ' + error.message);
    }
  }

  async printPreInvoice(data) {
    try {
      const preInvoice = data.preInvoice || data;
      return await this.printerService.printTicket(preInvoice, {
        paperWidth: data.paperWidth || '58',
        copies: data.copies || 1,
        businessName: data.business?.business_name || data.businessName,
      });
    } catch (error) {
      console.error('Error al imprimir pre-factura:', error);
      throw new Error('No se pudo imprimir la pre-factura: ' + error.message);
    }
  }

  async printProductLabel(data) {
    try {
      const product = data.product || data;
      return await this.printerService.printLabel(product, {
        size: data.size || '50x25',
        copies: data.copies || 1,
        type: data.type || 'barcode',
        showPrice: data.showPrice !== false,
        showName: data.showName !== false,
        showCode: data.showCode !== false,
        showCategory: data.showCategory || false,
        showBusinessName: data.showBusinessName || false,
        businessName: data.businessName || 'POSENT',
        useStockCount: data.useStockCount || false,
      });
    } catch (error) {
      console.error('Error al imprimir etiqueta:', error);
      throw new Error('No se pudo imprimir la etiqueta: ' + error.message);
    }
  }

  async printTestPage(data = {}) {
    try {
      const type = data.type || 'label';
      return await this.printerService.testPrint(type);
    } catch (error) {
      console.error('Error al imprimir página de prueba:', error);
      throw new Error('No se pudo imprimir la página de prueba: ' + error.message);
    }
  }

  async printFiscalInvoice(data) {
    return this.printInvoice(data);
  }

  async printReport(data) {
    return this.printInvoice(data);
  }
}

const printService = new PrintService();
export default printService;